export default __webpack_public_path__ + "locales/hy-AM/DownloadDialog.json?hash=0f37e9066791dcecfabfeca52c60d4df";